var wallOfFaces_data = [
["434","WALTER WILLIAMS JR","PORTSMOUTH","City Of Portsmouth","VA","US","ARMY","25-Sep-66","https://www.vvmf.org/Wall-of-Faces/56503/WALTER-WILLIAMS-JR-2/"]

];

(function($) {
	
	$(document).ready(function() {
		var oTable = $('#walloffacesTable').dataTable({
			data: wallOfFaces_data
			,responsive:true
			,columns: [
				 /* If adding a column, be sure to add it into the php as well or you will get a blank page
					 (even if the data isn't actually visible) */
				 { title: "ID","searchable": false,"visible":false  }
				,{ title: "Name", "className":"text-left"
					,"fnCreatedCell": function (nTd, sData, oData, iRow, iCol) {
						$(nTd).html("<a target='_blank' href='"+oData[8]+"'>"+sData+"</a>");
        			}
        		}
				,{ title: "Hometown","className":"text-left" }
				,{ title: "County"  ,"visible":false }
				,{ title: "State"   ,"searchable": false,"visible":false  }
				,{ title: "Country" ,"searchable": false,"visible":false  }
				,{ title: "Branch"  ,"className":"text-left" }
				,{ title: "Casualty Date", "className":"text-left" }
				,{ title: "Profile","searchable": false, "className":"text-center"
					,"fnCreatedCell": function (nTd, sData, oData, iRow, iCol) {
						$(nTd).html("<a target='_blank' href='"+sData+"'>Profile &amp; Submit Photo</a>");
        			}
        		}
	        ]
		})
	})
	
})(jQuery);